import { render, staticRenderFns } from "./SettingMemberShip.vue?vue&type=template&id=035384c4"
import script from "./SettingMemberShip.vue?vue&type=script&lang=js"
export * from "./SettingMemberShip.vue?vue&type=script&lang=js"
import style0 from "./SettingMemberShip.vue?vue&type=style&index=0&id=035384c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports